import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { agencySelector } from '../../selectors';

import Section from '../../components/Section';
import PhoneNumber from '../../components/PhoneNumber';
import AddressDirections from '../../components/AddressDirections';
import EmailAddress from '../../components/EmailAddress';

import { Card } from 'semantic-ui-react';

class AgencySection extends Component {
	render() {
		const { agency } = this.props;

		return (
			<Section name='agency' title='Agency' color='gray' mobileShow={this.props.mobileShow}>
				<Card.Group>
					{agency.agencies.map((agency, key) => {
						let emails = agency.emails || [];
						let phones = (agency.producer || agency).phones || [];
						if (phones.length === 0) {
							phones = agency.phones || [];
						}

						return (
							<Card className='agent' key={key}>
								<Card.Content header={agency.displayName} />

								<Card.Content>
									<Card.Description>
										{agency.producer && <div>{agency.producer.displayName}</div>}
										<AddressDirections destination={[agency.addressLine1, agency.addressLine2]}></AddressDirections>
										{emails[0] ? <EmailAddress emailAddress={emails[0]} subject='Indiana Farmers Insurance' text={emails[0]}></EmailAddress> : null}
										{phones[0] ? <PhoneNumber phoneNumber={phones[0]}></PhoneNumber> : null}
										{/* {agency.webSite ? <a href={agency.webSite} target="_blank">{agency.webSite}</a>: null}                             */}
									</Card.Description>
								</Card.Content>
								<Card.Content extra>{agency.policies.map((p) => p.policyNumber.toUpperCase()).join(' ')}</Card.Content>
							</Card>
						);
					})}
				</Card.Group>
			</Section>
		);
	}
}

AgencySection.propTypes = {
	actions: PropTypes.object.isRequired,
	agency: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
	return {
		agency: agencySelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {},
});

export default connect(mapStateToProps, mapDispatchToProps)(AgencySection);
